import { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import { errMsg } from "@/lib/api";
import useAdminApi from "@/hooks/useAdminApi";

export default function UsersTab() {
  const call = useAdminApi();
  const [data, setData] = useState({ roles: [], users: [] });
  const load = useCallback(() => {
    call("get", "/users").then(setData).catch((e) => toast.error(errMsg(e)));
  }, [call]);
  useEffect(() => {
    load();
  }, [load]);
  const change = async (u, role) => {
    try {
      await call("patch", `/users/${u.user_id}/role`, { role });
      toast.success("Role updated");
      load();
    } catch (e) {
      toast.error(errMsg(e));
    }
  };
  return (
    <div className="bg-white border border-[#E2DCD0] p-6" data-testid="admin-users">
      <p className="text-xs text-[#6b6b6b] mb-4">People who sign in start as "member" with no admin access. Promote trusted staff to admin.</p>
      {data.users.map((u) => (
        <div key={u.user_id} className="flex items-center justify-between gap-4 py-3 border-b border-[#E2DCD0]" data-testid={`admin-user-${u.user_id}`}>
          <span className="text-sm break-all">{u.email || u.user_id}</span>
          <select className="field !h-9 w-36" value={u.role} onChange={(e) => change(u, e.target.value)} data-testid={`admin-user-role-${u.user_id}`}>
            {data.roles.map((r) => <option key={r} value={r}>{r}</option>)}
          </select>
        </div>
      ))}
    </div>
  );
}
